var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.lead && _vm.lead.text)?_c('p',{staticClass:"C-headline-lead",domProps:{"innerHTML":_vm._f("truncate")(_vm.lead.text,_vm.maxChars)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }